import { useTranslation } from 'react-i18next';

type CharacterHintProps = {
	currentCount: number;
	maxCharacters: number;
	translationKey?: string;      
	defaultMessage?: string;     
	className?: string;
	id?: string;
};

export function CharacterHint({
	currentCount,
	maxCharacters,
	translationKey = 'text-input.character-hint',
	defaultMessage = 'You can type up to {{count}} characters.',
	className,
	id,
}: CharacterHintProps) {
	const { t } = useTranslation();

	return (
		<div
			id={id}
			className={`text-muted-foreground mt-1 flex items-center justify-between text-xs ${className ?? ''}`}
		>
			<span>
				{t(translationKey, defaultMessage, { count: maxCharacters })}
			</span>
			<span>
				{currentCount}/{maxCharacters}
			</span>
		</div>
	);
}
